import styled from "@emotion/styled";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { Button } from "components/UI";
import { useChurchStore } from "features/churches";
import { useCreateExpenseType, useExpenseStore } from "features/finances";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { BaseModal } from "./BaseModal";

const SmallText = styled.span`
  color: #8e8e8e;
  font-size: 10px;
  font-weight: 500;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Label = styled.label`
  color: #5b5b5b;
  font-size: 12px;
  font-weight: 500;
`;

const Input = styled.input`
  border-radius: 4px;
  border: 0.73px solid #b3b3b3;
  height: 40px;
  outline: none;
  padding: 8px;
`;

const Textarea = styled.textarea`
  resize: none;
  border-radius: 4px;
  border: 0.73px solid #b3b3b3;
  outline: none;
  padding: 8px;
  font-family: inherit;
`;

const expenseTypeSchema = yup.object({
  name: yup.string().required("Expense type name is required"),
  description: yup.string().required("Expense type description is required")
});

export function CreateExpenseTypeModal() {
  const createExpenseTypeOpen = useExpenseStore(
    state => state.createExpenseTypeOpen
  );
  const closeCreateExpenseTypeModal = useExpenseStore(
    state => state.closeCreateExpenseTypeModal
  );
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const createExpenseTypeMutation = useCreateExpenseType();

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      name: "",
      description: ""
    },
    resolver: yupResolver(expenseTypeSchema)
  });

  const onSubmit = data => {
    createExpenseTypeMutation.mutate(
      {
        churchId: selectedChurch?.id,
        expenseTypeData: data
      },
      {
        onSuccess: () => {
          reset();
        }
      }
    );
  };

  return (
    <BaseModal
      title="Create expense type"
      isOpen={createExpenseTypeOpen}
      onClose={closeCreateExpenseTypeModal}
      footer={
        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          <Button flavor="white" size="small">
            Cancel
          </Button>
          <Button size="small" onClick={handleSubmit(onSubmit)}>
            Create expense type
          </Button>
        </Stack>
      }
    >
      <Field>
        <Label htmlFor="name">Expense Type</Label>
        <Input id="name" {...register("name")} />
      </Field>
      <Field>
        <Label htmlFor="description">Description</Label>
        <Textarea id="description" rows={10} {...register("description")} />
      </Field>
      <SmallText>No more than 50 characters</SmallText>
    </BaseModal>
  );
}
